/**
 * 書込を止める拒否の理由。決定 ab のもとで書込を止めるのは**形式検査・対象の実在確認・
 * 楽観ロック**の 3 系統で、そのうち実在確認だけが向きの違う 2 つに分かれる。PJ の状態は
 * そのどれでもない 4 系統目である。
 *
 * - `input-schema`: zod `strictObject` の形式検査に落ちた（未知フィールド・必須欠け・型違い）
 * - `target-not-found`: 操作の対象が実在しない（upsert の親骨格 / rename・delete・revert の対象）
 * - `target-already-exists`: 移動先が既に埋まっている（`rename` の `newId` に別ノードが居る）
 * - `revision-conflict`: `baseRevision` と現在値が食い違う（更新時刻ベースの楽観ロック）
 * - `pj-already-merged`: 確定済みの PJ へ書こうとした（1 PJ = 1 リリース）
 *
 * `target-already-exists` を `violation` に落とさないのは、書いてしまうと移動先の既存
 * ノードが上書きで消え、`beforeValue` からの復元でも救えなくなるためである。制約 41 項目が
 * 「壊れていても後で直せる」から止めない側に置かれているのに対し、これは**後で直せない**。
 *
 * `pj-already-merged` も同じ理由で止める側に置く。確定済みの PJ へ積んだ行は、その PJ が
 * 二度と確定しない以上マスターへ入らない。書けてしまうと「PJ は `merged` なのに未反映の行が
 * ある」状態が生まれ、それこそが行ごとに状態を持たせていたときに検出できなかった**マージ漏れ**
 * そのものである。表現できてしまう状態は、いつか必ず作られる。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 書込を止める拒否理由 5 種の allowlist（形式検査 + 実在確認 2 方向 + 競合 + PJ の確定済み）
 * @graph-connects none
 */
export const REJECTION_REASONS = [
    'input-schema',
    'target-not-found',
    'target-already-exists',
    'revision-conflict',
    'pj-already-merged',
];
/**
 * 違反の重さ。**誰が消すか**で 2 段に分かれる。
 *
 * | 値 | 意味 | 消す人 |
 * |---|---|---|
 * | `error` | 仕様策定までに必須。仕様そのものが不完全 | 仕様作成者 |
 * | `warning` | 実装との紐づけが未登録。仕様は完成しうる | 実装者 |
 *
 * **軸は 1 本で決まる**: 外部グラフ（db-graph / SPG）との突合に由来する違反が `warning`、
 * それ以外がすべて `error` である。規則ごとに人が重さを決める形にすると、規則を足すたびに
 * 判断が要り、similar な規則が別の重さを持つ状態がすぐ生まれる。軸を 1 本にすれば機械的に
 * 決まり、「仕様は実装に先行できる」という設計（決定 aa・y-9）とも自動的に整合する —
 * 実装がまだ無いことは仕様の不備ではない。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 違反の重さ 2 段（仕様の不備 / 実装紐づけの未登録）の allowlist
 * @graph-connects none
 */
export const VIOLATION_SEVERITIES = ['error', 'warning'];
//# sourceMappingURL=violations.js.map